import { CoreIcon } from '../core-icon';
import gasStationFillSVG from '../../../src/images/icons/gas-station-fill.svg';

export const GasStationFillIcon = props => {
  return <CoreIcon src={gasStationFillSVG} {...props} />;
};
